<template>
  <main>
    <!-- Icono de hamburguesa -->
    <div class="hamburger-icon" @click="toggleMenu">
      <!-- Font Awesome icono de hamburguesa -->
      <i class="fas fa-bars" style="font-size: 24px;"></i>
    </div>

    <!-- Resto de tu contenido -->

    <!-- Menú desplegable -->
    <div
      class="menu"
      :class="{ 'menu-open': isMenuOpen }"
      @mouseout="startMenuCloseTimer"
      @mouseover="cancelMenuClose"
    >
      <ul>
        <!-- Agrega aquí tus elementos de menú -->

        <li>
          <router-link to="/new_invoice" @click="closeMenu"
            >Inicio</router-link
          >
        </li>
        <li>
          <router-link to="/" @click="closeMenu">Cerrar Sesión</router-link>
        </li>
        <!-- ... y así sucesivamente -->
      </ul>
    </div>

    <div class="sentence">
      <img src="./../assets/logo/Grupo 92.svg" width="35%" alt="osfatun" />
    </div>

    <section class="content">
      <h3 class="title mb-5 has-text-centered">
        ¡Hola {{ this.$store.state.name }}!
      </h3>
      <h4>Aqui puedes cambiar tu contraseña!</h4>

      <!-- Formulario para cambiar la contraseña usando Buefy -->
      <b-form @submit.prevent="changePassword">
        <b-field
          :type="{ 'is-danger': oldPasswordError }"
          label="Contraseña Anterior"
        >
          <b-input
            type="password"
            v-model="oldPassword"
            required
            minlength="8"
            placeholder="Contraseña Anterior"
          ></b-input>
        </b-field>

        <b-field
          :type="{ 'is-danger': newPasswordError }"
          label="Nueva Contraseña"
        >
          <b-input
            type="password"
            v-model="newPassword"
            required
            minlength="8"
            placeholder="Nueva Contraseña"
          ></b-input>
        </b-field>

        <b-field
          :type="{ 'is-danger': confirmPasswordError }"
          label="Confirmar Contraseña"
        >
          <b-input
            type="password"
            v-model="confirmPassword"
            required
            minlength="8"
            placeholder="Confirmar Contraseña"
          ></b-input>
        </b-field>

        <b-button type="is-info" @click="changePassword"
          >Cambiar Contraseña</b-button
        >
      </b-form>
    </section>

    <Footer>
      <p class="m-2">Desarrollado por</p>
      <img src="../assets/logo/logozaro1.svg" alt="zaro" />
    </Footer>
  </main>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { alertSuccess, alertFailed } from "@/helpers";
export default {
  data() {
    return {
      file: null,
      isFullPage: true,
       baseUrl: "https://api.osfatun.com.ar/",
      isMenuOpen: false,
      menuHovered: false,
      menuCloseTimer: null,
    };
  },
  // ...
  methods: {
    async changePassword() {
      try {
        if (this.newPassword.length < 8) {
          
          alertFailed("La contraseña debe tener al menos 8 caracteres");
          return;
        }

        if (this.newPassword !== this.confirmPassword) {
         
          alertFailed("Las contraseñas no coinciden.");
          
          return;
        }

        // Configuración de la solicitud Axios
        const config = {
          headers: {
            "Content-Type": "application/json", // Establece el tipo de contenido
            Authorization: `Bearer ${this.$store.state.token}`, // Agrega el token en el encabezado
          },
        };

        // Datos para la solicitud
        const requestData = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          id_user: this.$store.state.id_user,
          // Otros datos que necesites enviar
        };

        // Realiza la solicitud para cambiar la contraseña
        const response = await axios.post(
          this.baseUrl + "api/v1/prestador/changuepass",
          requestData,
          config
        );
        console.log(response);
        // Limpiar los campos después de cambiar la contraseña

        if (response.status === 200) {
          alertSuccess("Contraseña Actualizada!");
          this.$router.push('/new_invoice')
        }
      } catch (error) {
        if (error.response.status === 400) {
          // Si el código de estado es 400, muestra un mensaje de error específico
          alertFailed("La contraseña anterior no es correcta");
        } else {
          // Si es otro error, muestra un mensaje de error genérico
          this.errorMessage =
            "Hubo un error al cambiar la contraseña. Por favor, inténtalo de nuevo.";
        }
        console.error("Error al cambiar la contraseña:", error);
      }
    
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    startMenuCloseTimer() {
      this.menuCloseTimer = setTimeout(() => {
        this.isMenuOpen = false;
      }, 500); // Tiempo en milisegundos antes de cerrar el menú
    },
    cancelMenuClose() {
      clearTimeout(this.menuCloseTimer);
    },
    closeMenu() {
      this.isMenuOpen = false;
    },

    ...mapMutations(["setToken", "setName", "setIdInvoice"]),
  },
};
</script>

<style>
/* Estilos para el icono de hamburguesa y el menú desplegable */
.hamburger-icon {
  position: fixed;
  top: 20px;
  right: 20px;
  cursor: pointer;
  background-color: #fff;
  padding: 5px;
  padding-bottom: 2px;
  color: #017c9b;
  border-radius: 5%;
}

.menu {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 200px;
  background-color: #fff; /* Color de fondo del menú */
  transform: translateX(200px);
  transition: transform 0.3s ease-in-out;
}

.menu ul {
  list-style: none;
  padding: 20px;
}

.menu ul li {
  margin-bottom: 15px;
}

.menu ul li a {
  text-decoration: none;
  color: #000; /* Color del texto del menú por defecto */
}

.menu ul li a:hover {
  color: #017c9b; /* Color del texto cuando el enlace está en hover */
}

.menu-open {
  transform: translateX(0);
}

.login-card {
  max-width: 400px; /* Ajusta el ancho del b-card */
}
</style>
<style scoped>
.sentence {
  background-image: url("./../assets/fondo.png");
  background-size: 100%;
  width: 100%;
  background-repeat: no-repeat;
  max-height: 33vh;
  padding: 2em;
}
.sentence img {
  padding: 1em;
  width: 220px;
  margin: 0 auto;
  text-align: center;
  display: block;
}
.content {
  position: relative;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
}
h3.title {
  font-weight: bold;
  font-size: 34px;
  color: #00758f;
  line-height: 1.9rem;
  margin: 0 50px;
}
.second-container {
  max-width: 90%;
  margin: 0 auto;
}
.hr {
  background-color: #eeeeee;
  margin: 50px 0;
}
h5.title {
  font-weight: 500;
  font-size: 22px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 6%;
}

.centered-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Ajusta esta altura según tus necesidades */
  border: 1px dashed #d9d9d9;
  margin-top: 2em;
  padding: 2em;
  font-weight: 100;
  font-size: 14px;
}

.cont-h3 {
  background-color: rgba(0, 143, 40, 1);
  color: white;
  font-size: 15px;
  margin: 0 10em;
}
.button-charge {
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
  margin-right: 10px;
  padding: 10px 20px;
}
.button-charge img {
  vertical-align: middle; /* Alinear verticalmente la imagen con el texto */
  margin-right: 10px;
}
.button-next {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1em;
}
.button-next h3 {
  display: flex; /* Usamos flexbox para alinear elementos internos */
  justify-content: center;
  padding-top: 1px;
}

footer {
  margin-top: 15em;
  display: flex;
  justify-content: center;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 10px;
}

@media screen and (max-width: 42em) {
  .sentence {
    max-height: 15vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 3em;
  }
  .sentence img {
    width: 35%;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 40%;
    left: 15%;
    display: block;
    padding-bottom: 0;
  }

  .content {
    position: relative;
    background: white;
    max-width: 95%;
    padding: 40px 20px;
    margin: 1em auto;
  }

  h3.title {
    font-size: 29px;
    margin: 0;
  }
  h5.title {
    font-size: 15px;
  }
  .cont-h3 {
    margin: 0 2em;
  }
  footer {
    margin-top: 12em auto;
  }
}
</style>
